import gql from "graphql-tag";

const ARTICLE_QUERY = gql`
  query Article($slug: String!) {
    articles(where: { slug: $slug }) {
      slug
      title
      content
      description
      categories {
        name
      }
      image {
        url
      }
      published
    }
  }
`;

export default ARTICLE_QUERY;
